import { defineMessages } from 'react-intl';

export const FLAME_TOOLTIP_MESSAGES = defineMessages({
  values: {
    id: 'pZYcJHuudIiUoTQ3',
    defaultMessage: 'Values',
    description: 'Column header label in the flame tooltip.',
  },
  total: {
    id: 'aqgV26FymxiNNhI0',
    defaultMessage: 'Total',
    description: 'Row label for the total duration/value in the flame tooltip.',
  },
  self: {
    id: 'PKJV6NXPfso3pkdg',
    defaultMessage: 'Self',
    description:
      'Row label for the self (exclusive) duration/value in the flame tooltip.',
  },
  isolateSegment: {
    id: 'ze9ge3utWHDeoMzu',
    defaultMessage: 'Isolate segment',
    description:
      'Footer action label in the flame tooltip that zooms the chart to the selected segment.',
  },
  children: {
    id: 'pJzqfzmBdDOee48O',
    defaultMessage: '{count, plural, one {# child} other {# children}}',
    description:
      'Subheader in the flame tooltip showing how many children a segment has.',
  },
});
